<template>
  <div class="color-sample n2-west3">
    <section class="flex center grow adjust-bottom">
      <div class="box grow" />
      <div class="box right">
        <p class="extra-small-text adjust-line-height">
          俗名
        </p>
      </div>
      <div class="box flex column">
        <div class="box top">
          <p class="extra-small-text adjust-line-height">
            享年 八十八歳
          </p>
        </div>
        <div class="box top">
          <p class="extra-small-text adjust-line-height">
            源頼朝
          </p>
        </div>
      </div>
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="extra-small-text">
          平成三年 十二月三十 一日 没
        </p>
      </div>
      <div class="box grow" />
    </section>
    <section />
    <section class="flex center grow adjust-bottom">
      <div class="box grow" />
      <div class="box right">
        <p class="extra-small-text adjust-line-height">
          俗名
        </p>
      </div>
      <div class="box flex column">
        <div class="box top">
          <p class="extra-small-text adjust-line-height">
            享年 八十八歳
          </p>
        </div>
        <div class="box top">
          <p class="extra-small-text adjust-line-height">
            源頼朝
          </p>
        </div>
      </div>
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="extra-small-text">
          平成三年 十二月三十 一日 没
        </p>
      </div>
      <div class="box grow" />
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";
</style>
